import { ProductType } from '@inter-ikea-storageone/range';
import ColorFilter from 'filters/ColorFilter/ColorFilter';
import DepthFilter from 'filters/SizeFilter/DepthFilter';
import HeightFilter from 'filters/SizeFilter/HeightFilter';
import WidthFilter from 'filters/SizeFilter/WidthFilter';
import IconTypeFilter from 'filters/TypeFilter/IconTypeFilter';
import { FilterType } from 'rangeConfig/@types';
import HandlesTypeIcon from 'rangeConfig/Icons/HandlesType.svg?react';
import KnobsTypeIcon from 'rangeConfig/Icons/KnobsType.svg?react';

export const widthFilter = {
  component: WidthFilter,
  id: 'width',
  type: FilterType.FILTER
};

export const widthFilterWithSizeLabel = {
  title: 'storageone.sizeFilterLabel',
  ...widthFilter
};

export const depthFilter = {
  component: DepthFilter,
  id: 'depth',
  type: FilterType.FILTER
};

export const depthFilterWithSizeLabel = {
  title: 'storageone.sizeFilterLabel',
  ...depthFilter
};

export const heightFilter = {
  component: HeightFilter,
  id: 'height',
  type: FilterType.FILTER
};

export const heightFilterWithSizeLabel = {
  title: 'storageone.sizeFilterLabel',
  ...heightFilter
};

export const colorFilter = {
  component: ColorFilter,
  title: 'storageone.colorFilterLabel',
  id: 'color',
  type: FilterType.FILTER
};

export const handlesTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'handles',
      name: 'storageone.filterOptionHandles',
      icon: HandlesTypeIcon,
      types: [ProductType.HANDLE, ProductType.EDGE_HANDLE]
    },
    {
      id: 'knobs',
      name: 'storageone.filterOptionKnobs',
      icon: KnobsTypeIcon,
      types: [ProductType.KNOB]
    }
  ]
};
